/**
 * DOM Ready
 *
 * @param {function} callback Function to call on DOM Ready
 */
export const useReady = (callback) => {
  if (!callback) return;

  if (document.readyState !== 'loading') {
    callback();
    return;
  }

  document.addEventListener('DOMContentLoaded', callback);
};

/**
 * Load a script.
 *
 * @param {string} src Script URL.
 * @param {function} onLoad Optional on load callback.
 */
export const loadScript = (src, onLoad) => {
  const doc = document;
  const script = doc.createElement('script');

  if (onLoad) {
    script.addEventListener('load', onLoad);
  }

  script.type = 'text/javascript';
  script.src = src;

  const target = doc.getElementsByTagName('head')[0] || doc.body || doc.documentElement;

  target.appendChild(script);
};

export const loadScriptAsync = async (src, onLoad) => {
  return new Promise((resolve) => {
    loadScript(src, () => {
      if (onLoad) {
        onLoad();
      }
      resolve();
    });
  });
};
